import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import '@morefunos/ui/tokens.css';
import '@morefunos/ui/base.css';
import './admin.css';
import {App} from './App.tsx';
import {createAdminComboPort} from './admin-combo-port.ts';
import {resolveAdminComboRuntimeHost} from './runtime.ts';

const root = document.getElementById('root');
if (!root) throw new Error('ADMIN_ROOT_REQUIRED');
const host = resolveAdminComboRuntimeHost();
let seq = 0;
const port = host ? createAdminComboPort({
  controlPlane: host.controlPlane,
  actorId: host.actorId,
  permissions: host.permissions,
  now: () => new Date().toISOString(),
  nextId: (kind) => `${kind}:${globalThis.crypto?.randomUUID?.() ?? `${Date.now()}:${++seq}`}`,
}) : null;
createRoot(root).render(<StrictMode><App port={port} /></StrictMode>);
